import type { TableCellStyle } from '../../models/table/tableCell.types';

export type TableCellClipboardDockedShape = {
  type: string;
  category?: string;
  w?: number;
  h?: number;
  width?: number;
  height?: number;
  text?: string;
  name?: string;
  fillColor?: string;
  strokeColor?: string;
  strokeWidth?: number;
  attrs?: Record<string, unknown>;
  offset?: { x: number; y: number };
};

export type TableCellClipboardPayload = {
  version: 1;
  text?: string;
  style?: TableCellStyle;
  dockedShapes?: TableCellClipboardDockedShape[];
  cells?: {
    items: Array<{
      r: number;
      c: number;
      text?: string;
      style?: TableCellStyle;
      dockedShapes?: TableCellClipboardDockedShape[];
    }>;
  };
};

let payload: TableCellClipboardPayload | null = null;

export const TableCellClipboard = {
  set(next: TableCellClipboardPayload): void {
    payload = JSON.parse(JSON.stringify(next)) as TableCellClipboardPayload;
  },
  get(): TableCellClipboardPayload | null {
    return payload ? (JSON.parse(JSON.stringify(payload)) as TableCellClipboardPayload) : null;
  },
  clear(): void {
    payload = null;
  },
  has(): boolean {
    return !!payload;
  },
};

